import React from "react"
import "./Card.css"
import ToolTip from "../Tooltip"

function Card({
  title,
  optional,
  endText,
  endTextClass,
  tooltip,
  children,
  description,
  className
}) {
  return (
    <div className={`Card${(className && " " + className) || ""}`}>
      <div className="Card-header">
        {title && <h1>{title}</h1>}
        {optional && <span className="optional">(optional)</span>}
        {endText && (
          <span className={`endText ${endTextClass && endTextClass}`}>
            {endText}
          </span>
        )}
        {tooltip && <ToolTip tooltip={tooltip} />}
      </div>
      {description && <p>{description}</p>}
      <div className="Card-content">{children}</div>
    </div>
  )
}

export default Card
